import { useTaxInvoice } from '~hooks/queries/tax-invoice/query';
import { useDemoAwareCompanyId } from '~hooks/useDemoAwareCompanyId';
import { TaxInvoice, TaxInvoiceType } from '~models/tax-invoice';

import TaxInvoiceResultDrawer from '../TaxInvoice/TaxInvoiceResultDrawer';
import { mapTaxInoiveRawItemToIssueInvoiceItem } from '../TaxInvoice/utils';

interface Props {
  type?: TaxInvoiceType;
  id: string;
  isOpen: boolean;
  onClose: () => void;
}

const SettlementTaxInvoiceResultDrawer: React.FC<Props> = ({ type, id, isOpen, onClose }) => {
  if (!type || !id) return null;
  const { companyId } = useDemoAwareCompanyId();
  const { data, refetch } = useTaxInvoice(companyId, type, id);
  const invoiceInfo = data?.Data?.data;

  const mappedTaxInvoice = invoiceInfo
    ? mapTaxInoiveRawItemToIssueInvoiceItem(invoiceInfo as unknown as TaxInvoice)
    : undefined;

  if (!mappedTaxInvoice) return null;

  return (
    <TaxInvoiceResultDrawer
      width={520}
      showSync
      onSyncFinish={() => refetch()}
      type={type}
      item={{
        ...mappedTaxInvoice,
      }}
      title="세금계산서 상세"
      open={isOpen}
      onClose={onClose}
    />
  );
};

export default SettlementTaxInvoiceResultDrawer;
